import React from 'react'

const withNofollow = (WrappedComponent) => {
  class WithNofollow extends React.PureComponent {
    render() {
      return <WrappedComponent {...this.props} rel="nofollow" />
    }
  }

  WithNofollow.displayName = `${WrappedComponent.displayName}WithNofollow`

  return WithNofollow
}
export default withNofollow
